import { useDispatch } from 'react-redux';
import { logOut, logOutReasons } from 'stash/actions';
import { DismissPayloadType } from 'stash/constants/bridgeMessageTypes';
import { isNativeWebview } from 'stash/utils';
import { dismiss } from 'stash/utils/bridgeMessages';
import { sendMessage } from 'stash/utils/native-bridge';

const useLogout = () => {
	const dispatch = useDispatch();

	const logoutUser = () => {
		if (isNativeWebview()) {
			sendMessage(dismiss(DismissPayloadType.LOGOUT));
		} else {
			dispatch(logOut(logOutReasons.LOGGED_OUT));
		}
	};

	const logoutUserDueToTimeout = () => {
		dispatch(logOut(logOutReasons.TIMED_OUT));
	};

	return {
		logoutUser,
		logoutUserDueToTimeout,
	};
};

export default useLogout;
